var getCategoryProducts = function (products, categoryProductIds) {
    if (products === void 0) { products = []; }
    return categoryProductIds
        .split(',')
        .map(function (id) { return products === null || products === void 0 ? void 0 : products.find(function (product) { return product.id === id; }); })
        .filter(function (item) { return !!item; });
};
export default getCategoryProducts;
